module.exports = __webpack_public_path__ + "bg-img.cc84d41b081642efb15b.png";


//////////////////
// WEBPACK FOOTER
// C:/Works/Respite/respite_app/UI/src/assets/Images/bg-img.png
// module id = ../../../../../src/assets/Images/bg-img.png
// module chunks = 2